import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Layout } from "../components/Navbar";
import { api, safeInternalPath } from "../api";
import { toast } from "sonner";

export default function RegisterPro() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const nextPath = safeInternalPath(params.get("next"));
  const [f, setF] = useState({
    email:"", password:"", professional_title:"", first_name:"", last_name:"", country:"IT",
    profession:"", specialization:"", board:"", board_number:"",
    vat_id:"", address_street:"", address_city:"", phone:"", accept_terms:false
  });
  const set = (k, v) => setF({ ...f, [k]: v });
  const submit = async (e) => {
    e.preventDefault();
    if (!f.professional_title) return toast.error(t("auth.pro_title_label"));
    if (!f.accept_terms) return toast.error("Devi accettare Termini");
    try {
      await api.post("/auth/register/professional", f);
      toast.success("Registrazione ricevuta. Conferma email e attendi approvazione admin.");
      nav(`/confirm-email?email=${encodeURIComponent(f.email)}${nextPath ? `&next=${encodeURIComponent(nextPath)}` : ""}`);
    } catch (err) { toast.error(err.response?.data?.detail || "Errore"); }
  };
  return (<Layout><div className="yp-container max-w-3xl py-10">
    <h1 className="text-3xl font-bold mb-6">{t("auth.register_pro_title")}</h1>
    <form onSubmit={submit} className="yp-card p-6 space-y-4" data-testid="register-pro-form">
      <div className="grid md:grid-cols-2 gap-4">
        {[["email","email","email"],["password","password","password"]].map(([k,l,ty])=>(
          <input key={k} required className="yp-input" placeholder={t(l)} type={ty} value={f[k]} onChange={e=>set(k,e.target.value)} data-testid={`reg-pro-${k}`} />
        ))}
        <select required className="yp-input md:col-span-2" value={f.professional_title} onChange={e=>set("professional_title",e.target.value)} data-testid="reg-pro-title" aria-label={t("auth.pro_title_label")}>
          <option value="" disabled>{t("auth.pro_title_label")}</option>
          <option value="doctor_m">{t("auth.pro_title_m")}</option>
          <option value="doctor_f">{t("auth.pro_title_f")}</option>
          <option value="other">{t("auth.pro_title_other")}</option>
        </select>
        {[["first_name","auth.first_name","text"],["last_name","auth.last_name","text"],
          ["phone","auth.phone","tel"],
          ["profession","auth.pro_profession","text"],["specialization","auth.pro_specialization","text"],
          ["board","auth.pro_board","text"],["board_number","auth.pro_board_number","text"],
          ["vat_id","auth.pro_vat","text"]].map(([k,l,ty])=>(
          <input key={k} required className="yp-input" placeholder={t(l)} type={ty} value={f[k]} onChange={e=>set(k,e.target.value)} data-testid={`reg-pro-${k}`} />
        ))}
        <select className="yp-input" value={f.country} onChange={e=>set("country",e.target.value)} data-testid="reg-pro-country">
          {["IT","DE","FR","AT","CH","US","UK"].map(c=><option key={c}>{c}</option>)}
        </select>
        <input required className="yp-input" placeholder={t("auth.address_street")} value={f.address_street} onChange={e=>set("address_street",e.target.value)} data-testid="reg-pro-street" />
        <input required className="yp-input" placeholder={t("auth.address_city")} value={f.address_city} onChange={e=>set("address_city",e.target.value)} data-testid="reg-pro-city" />
      </div>
      <label className="flex items-center gap-2 text-sm">
        <input type="checkbox" checked={f.accept_terms} onChange={e=>set("accept_terms",e.target.checked)} data-testid="reg-pro-terms" />
        {t("auth.terms_agree")} — inclusa autodichiarazione professionale
      </label>
      <button className="yp-btn yp-btn-primary w-full" type="submit" data-testid="reg-pro-submit">{t("nav.register")}</button>
    </form>
  </div></Layout>);
}
